<template>
  <div class="">
    <cooperators> </cooperators>
  </div>
</template>

<script>
import Cooperators from "@/components/profile/cooperators/index.vue";

import { mapActions } from "vuex";

export default {
  props: {
    msg: String,
  },
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    Cooperators,
  },
  created() {
    this.notifyQueue({
      text: "Configurazione",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Collaborazioni orizzontali",
      path: "brokers.index1",
      level: 2,
    });
  },
};
</script>
